<mat-form-field #formFieldContainer class="sc-numeric-wrapper" [floatLabel]="shouldNotFloat?'never':'auto'">
  <mat-label #labelContainer (click)="toggleTooltip(tooltip)" [ngClass]="{'mandatory': componentDefinition?.mandatory}">
    {{componentDefinition?.label}}
  </mat-label>

  <div
    class="labelToolTipContainer"
    #tooltip="matTooltip"
    matTooltip="{{componentDefinition.label}}"
    [matTooltipDisabled]="showToolTip(tooltip, formFieldContainer, labelContainer)">
  </div>

  <input matInput
         #inputFormatted
         [value]="formattedValue"
         *ngIf="formattedValue"
         class="formatted-input"
         [disabled]="componentDefinition.enabled==false"
         (blur)="showFormattedValue($event)"
         (focus)="showInputField(inputFormatted)"
  />

  <input matInput
         #input
         type="number"
         *ngIf="!formattedValue"
         [formControl]="formControl"
         [min]="componentDefinition.min"
         [max]="componentDefinition.max"
         [step]="componentDefinition.step"
         (blur)="showFormattedValue($event)"
         (input)="validateNumericInput($event)"
         (focus)="focusNumericInput()"
         [ngClass]="{'hide-inc-dec-btn': componentDefinition.afterStr, 'right-align': componentDefinition.rightAlign}"
  />
  <span matPrefix *ngIf="componentDefinition.beforeStr">{{componentDefinition.beforeStr}}&nbsp;</span>
  <span matSuffix *ngIf="componentDefinition.afterStr">{{componentDefinition.afterStr}}</span>
</mat-form-field>
<ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>
